import {Atividade} from 'src/app/core/atividade';
import {Component, Input, OnInit} from '@angular/core';
import {Acoes} from "../../../../core/acoes";
import {DataUtilService} from "../../../../services/commons/data-util.service";
import {Acesso} from "../../../../core/acesso";
import {AcaoExecutada} from "../../../../core/acao-executada";
import {MetaAcao} from "../../../../core/meta-acao";

@Component({
    selector: 'cadastrar-acoes',
    templateUrl: './cadastrar-acoes-oficina.component.html',
    styleUrls: ['./cadastrar-acoes-oficina.component.css']
})
export class CadastrarAcoesOficinaComponent implements OnInit {

    @Input() perfilAcesso: Acesso;

    @Input() oficina: Atividade;
    acao: Acoes = new Acoes();
    metasAcoes: MetaAcao[] = [];


    listaLocalExecucao: any[] = [
        {tipo: 'Interna', flag: 'I'},
        {tipo: 'Externa', flag: 'E'}
    ];

    isAtualizar = false;

    constructor(private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.acao = new Acoes();
        this.acao.acoesExecutadas = [];
        this.acao.metas = [];
    }

    zerarCombos() {
        this.acao = new Acoes();
        this.acao.acoesExecutadas = [];
        this.acao.metas = [];
    }

    adicionar() {
        const acaoAtividade = new Acoes();
        Object.assign(acaoAtividade, this.acao);

        if (!this.oficina.acoes) {
            this.oficina.acoes = [];
        }

        acaoAtividade.dataInicio = this.dataUtilService.getDataTruncata(this.acao.dataInicio);
        acaoAtividade.acoesExecutadas.forEach(acaoExecutada => {
            acaoExecutada.dataInicio = this.dataUtilService.getDataTruncata(acaoExecutada.dataInicio);
            acaoExecutada.dataFim = this.dataUtilService.getDataTruncata(acaoExecutada.dataFim);

            if (acaoExecutada.colaboradores)
                acaoExecutada.colaboradores = acaoExecutada.colaboradores.filter(colaborador => colaborador.funcionario?.id);

            if (acaoExecutada.frequencias)
                acaoExecutada.frequencias = acaoExecutada.frequencias.filter(frequencia => frequencia.aluno?.id);

            if (acaoExecutada.metas)
                acaoExecutada.metas = acaoExecutada.metas.filter(meta => meta.metaAcao?.metaObjetivo?.id);
        })
        if (acaoAtividade.metas)
            acaoAtividade.metas = acaoAtividade.metas.filter(meta => meta.metaObjetivo?.id);

        this.oficina.acoes.push(acaoAtividade);
        this.zerarCombos();
    }

    atualizar() {
        this.acao.dataInicio = this.dataUtilService.getDataTruncata(this.acao.dataInicio);
        this.acao.acoesExecutadas.forEach(acaoExecutada => {
            acaoExecutada.dataInicio = this.dataUtilService.getDataTruncata(acaoExecutada.dataInicio);
            acaoExecutada.dataFim = this.dataUtilService.getDataTruncata(acaoExecutada.dataFim);

            if (acaoExecutada.colaboradores)
                acaoExecutada.colaboradores = acaoExecutada.colaboradores.filter(colaborador => colaborador.funcionario?.id);

            if (acaoExecutada.frequencias)
                acaoExecutada.frequencias = acaoExecutada.frequencias.filter(frequencia => frequencia.aluno?.id);

            if (acaoExecutada.metas)
                acaoExecutada.metas = acaoExecutada.metas.filter(meta => meta.metaAcao?.metaObjetivo?.id);
        })
        if (this.acao.metas)
            this.acao.metas = this.acao.metas.filter(meta => meta.metaObjetivo?.id);

        const index = this.oficina.acoes.indexOf(this.oficina.acoes.find(col => col.id === this.acao.id));
        this.oficina.acoes.splice(index, 1, this.acao);

        this.isAtualizar = false;
        this.zerarCombos();
    }

    atualizarAcao(acaoAtividade: Acoes) {
        this.isAtualizar = true;
        this.acao = acaoAtividade;
        this.metasAcoes.push(...acaoAtividade.metas);
    }

    cancelar() {
        this.zerarCombos();
        this.isAtualizar = false;
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    addAcaoExecutada() {
        if (!this.acao.acoesExecutadas) {
            this.acao.acoesExecutadas = [];
        }

        const acaoExecutada: AcaoExecutada = new AcaoExecutada();
        acaoExecutada.id = undefined;
        acaoExecutada.descricao = "";
        this.acao.acoesExecutadas.push(acaoExecutada);
    }

    addMeta() {
        if (!this.acao.metas) {
            this.acao.metas = [];
        }

        const meta: MetaAcao = new MetaAcao();
        meta.id = undefined;
        this.acao.metas.push(meta);
        this.metasAcoes.push(meta);
    }

}
